export default __webpack_public_path__ + "static/media/broker-success-icon.c7bce0ec.svg";